import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b97bd24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = { class: "inner-panel" }
const _hoisted_5 = { class: "panel-content-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "error-alert"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "warning", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Im Zusammenhang mit diesem Schritt wurden 3 Fehler erkannt. "),
  /*#__PURE__*/_createElementVNode("b", null, "Jetzt ansehen")
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "header-name" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "elements" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_flow_panel_content_entry = _resolveComponent("flow-panel-content-entry")!
  const _component_flow_panel_content_block = _resolveComponent("flow-panel-content-block")!
  const _component_flow_panel_content_delay = _resolveComponent("flow-panel-content-delay")!
  const _component_flow_panel_content_split = _resolveComponent("flow-panel-content-split")!
  const _component_flow_panel_content_intent = _resolveComponent("flow-panel-content-intent")!
  const _component_flow_panel_content_condition = _resolveComponent("flow-panel-content-condition")!
  const _component_flow_panel_content_flow = _resolveComponent("flow-panel-content-flow")!
  const _component_flow_panel_content_note = _resolveComponent("flow-panel-content-note")!
  const _component_flow_panel_content_outlet = _resolveComponent("flow-panel-content-outlet")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "elevated",
    class: _normalizeClass(["flow-panel", { large: _ctx.large }]),
    ref: "panel",
    onScroll: _ctx.onScroll
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["header-title", { scroll: _ctx.scrollTop }])
      }, [
        _createVNode(_Transition, {
          name: 'name-' + (_ctx.showName ? 'in' : 'out'),
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.showName)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.name), 1))
              : (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.namesByType[_ctx.type]) + " bearbeiten", 1))
          ]),
          _: 1
        }, 8, ["name"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_md_tooltip, {
            position: "bottom",
            text: "Info"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "info",
                grey: ""
              })
            ]),
            _: 1
          }),
          _createVNode(_component_md_tooltip, {
            position: "bottom",
            text: "Analyse"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "insights",
                grey: ""
              })
            ]),
            _: 1
          }),
          _createVNode(_component_md_tooltip, {
            position: "bottom",
            text: "Duplizieren"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "content_copy",
                grey: "",
                disabled: _ctx.copyDisabled,
                onClick: _ctx.duplicateNode
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_md_tooltip, {
            position: "bottom",
            text: "Löschen"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, {
                variant: "icon",
                icon: "delete_forever",
                grey: "",
                disabled: _ctx.deleteDisabled,
                onClick: _ctx.deleteNode
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ])
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_transition_fade, null, {
          default: _withCtx(() => [
            (_ctx.showOverlay)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "panel-overlay",
                  style: _normalizeStyle({ height: _ctx.panelHeight + 'px' })
                }, null, 4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_md_input_field, {
              label: "Name",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              variant: "outlined",
              error: false,
              size: "small"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_11, [
              (!_ctx.editDescription)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.description && _ctx.description.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.description), 1))
                      : (_openBlock(), _createElementBlock("em", {
                          key: 1,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editDescription = true))
                        }, "Beschreibung hinzufügen")),
                    _createVNode(_component_md_tooltip, {
                      position: "left",
                      text: "Beschreibung ändern"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_md_button, {
                          variant: "icon",
                          icon: "edit",
                          mode: "icon_small",
                          grey: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editDescription = true))
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_md_input_field, {
                      label: "Beschreibung",
                      modelValue: _ctx.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                      variant: "outlined",
                      error: false,
                      size: "small"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_md_button, {
                      class: "standalone-button",
                      variant: "icon",
                      icon: "check",
                      mode: "icon_small",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editDescription = false))
                    })
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.block.id == 'entry')
              ? (_openBlock(), _createBlock(_component_flow_panel_content_entry, {
                  key: 0,
                  data: _ctx.block,
                  "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.block) = $event)),
                  onOverlay: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOverlay = $event)),
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close'))),
                  ref: "content"
                }, null, 8, ["data"]))
              : (_ctx.block.type == 'elements' || !_ctx.block.type)
                ? (_openBlock(), _createBlock(_component_flow_panel_content_block, {
                    key: 1,
                    data: _ctx.block,
                    "onUpdate:data": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.block) = $event)),
                    onOverlay: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showOverlay = $event)),
                    onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close'))),
                    ref: "content"
                  }, null, 8, ["data"]))
                : (_ctx.block.type == 'delay')
                  ? (_openBlock(), _createBlock(_component_flow_panel_content_delay, {
                      key: 2,
                      data: _ctx.block,
                      "onUpdate:data": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.block) = $event)),
                      onOverlay: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showOverlay = $event)),
                      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close'))),
                      ref: "content"
                    }, null, 8, ["data"]))
                  : (_ctx.block.type == 'split')
                    ? (_openBlock(), _createBlock(_component_flow_panel_content_split, {
                        key: 3,
                        data: _ctx.block,
                        "onUpdate:data": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.block) = $event)),
                        onOverlay: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showOverlay = $event)),
                        onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('close'))),
                        ref: "content"
                      }, null, 8, ["data"]))
                    : (_ctx.block.type == 'intent')
                      ? (_openBlock(), _createBlock(_component_flow_panel_content_intent, {
                          key: 4,
                          data: _ctx.block,
                          "onUpdate:data": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.block) = $event)),
                          onOverlay: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showOverlay = $event)),
                          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('close'))),
                          ref: "content"
                        }, null, 8, ["data"]))
                      : (_ctx.block.type == 'condition')
                        ? (_openBlock(), _createBlock(_component_flow_panel_content_condition, {
                            key: 5,
                            data: _ctx.block,
                            "onUpdate:data": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.block) = $event)),
                            onOverlay: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showOverlay = $event)),
                            onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('close'))),
                            ref: "content"
                          }, null, 8, ["data"]))
                        : (_ctx.block.type == 'flow')
                          ? (_openBlock(), _createBlock(_component_flow_panel_content_flow, {
                              key: 6,
                              data: _ctx.block,
                              "onUpdate:data": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.block) = $event)),
                              onOverlay: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showOverlay = $event)),
                              onClose: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('close'))),
                              ref: "content"
                            }, null, 8, ["data"]))
                          : (_ctx.block.type == 'note')
                            ? (_openBlock(), _createBlock(_component_flow_panel_content_note, {
                                key: 7,
                                data: _ctx.block,
                                "onUpdate:data": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.block) = $event)),
                                onOverlay: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showOverlay = $event)),
                                onClose: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('close'))),
                                ref: "content"
                              }, null, 8, ["data"]))
                            : (_ctx.block.type == 'outlet')
                              ? (_openBlock(), _createBlock(_component_flow_panel_content_outlet, {
                                  key: 8,
                                  data: _ctx.block,
                                  "onUpdate:data": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.block) = $event)),
                                  onOverlay: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showOverlay = $event)),
                                  onClose: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('close'))),
                                  ref: "content"
                                }, null, 8, ["data"]))
                              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["footer", { scroll: _ctx.scrollBottom }])
      }, [
        _createVNode(_component_md_button, {
          variant: "text",
          grey: "",
          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.cancel()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Abbrechen")
          ]),
          _: 1
        }),
        _createVNode(_component_md_button, {
          variant: "filled",
          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.save()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Ok")
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onScroll"]))
}